import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { staff_assign, staff_project } from './api';

const initialState = {
  loading: false,
  staffingStats: null,
  staffAssignments: [],
  staffProjects: []
};

const actions = {
  FETCH_STAFF_ASSIGNMENTS: 'staffing/FETCH_STAFF_ASSIGNMENTS',
  FETCH_STAFF_PROJECTS: 'staffing/FETCH_STAFF_PROJECTS'
};

export const fetchStaffAssignments = createAsyncThunk(
  actions.FETCH_STAFF_ASSIGNMENTS,
  async (payload) => {
    const response = await staff_assign('get-staff-assignment', payload); // or your actual URL segment
    console.log(response);
    return response;
  }
);

// ===== STAFF PROJECTS =====
export const fetchStaffProjects = createAsyncThunk(
  actions.FETCH_STAFF_PROJECTS,
  async (payload) => {
    const response = await staff_project('get-project-staffing', payload);
    console.log('Staff Projects Response:', response);
    return response;
  }
);

export const staffingSlice = createSlice({
  name: 'staffing',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffAssignments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffAssignments.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg, data, staffing_stats } = action.payload;

        if (success) {
          state.staffAssignments = data || [];
          state.staffingStats = staffing_stats || null;
        } else {
          message.error(msg || 'Failed to fetch staff assignments');
        }
      })
      .addCase(fetchStaffAssignments.rejected, (state, action) => {
        state.loading = false;
        message.error(
          action?.error?.message ||
            'Something went wrong while fetching staff assignments'
        );
      })
      .addCase(fetchStaffProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffProjects.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload;

        if (success) {
          state.staffProjects = data || [];
        } else {
          message.error(msg || 'Failed to fetch staff projects');
        }
      })
      .addCase(fetchStaffProjects.rejected, (state, action) => {
        state.loading = false;
        message.error(
          action?.error?.message ||
            'Something went wrong while fetching staff projects'
        );
      });
  }
});

export const selectStaffingSlice = (state) => state.staffing;

export default staffingSlice.reducer;
